export const useSystemSettings = () => {
  const systemSettings = useState<
    GetEnterpriseSystemSettings200ResponseSettings | undefined
  >('systemSettings', () => undefined)
  const refreshSystemSettings = async (force: boolean = false) => {
    if (!force && systemSettings.value) {
      return
    }
    const result = await useApi(SystemApi, {
      noAuthToken: true,
      noTokenRefresh: true,
    }).getEnterpriseSystemSettings()
    systemSettings.value = result.settings
  }
  return {
    refreshSystemSettings,
    systemSettings: computed(() => systemSettings.value),
  }
}
